/* eslint-disable */
export default {
  "meta": {
    "table_type": "opex_summary",
    "title": "Table A"
  },
  "data": [
    {
      "meta": {},
      "data": [
        {
          "value": null,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": null,
          "shade": false,
          "format": null,
          "alignment": null
        },
        {
          "value": "T-12",
          "is_header": true,
          "is_total": false,
          "is_subtotal": false,
          "span": 3,
          "stylings": [],
          "shade": false,
          "format": "string",
          "alignment": "center"
        },
        {
          "value": null,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": null,
          "shade": false,
          "format": null,
          "alignment": null
        },
        {
          "value": "T-12 (Adjusted)",
          "is_header": true,
          "is_total": false,
          "is_subtotal": false,
          "span": 3,
          "stylings": [],
          "shade": false,
          "format": "string",
          "alignment": "center"
        },
        {
          "value": null,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": null,
          "shade": false,
          "format": null,
          "alignment": null
        },
        {
          "value": "Pro Forma",
          "is_header": true,
          "is_total": false,
          "is_subtotal": false,
          "span": 3,
          "stylings": [],
          "shade": false,
          "format": "string",
          "alignment": "center"
        }
      ]
    },
    {
      "meta": {},
      "data": [
        {
          "value": null,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": null,
          "shade": false,
          "format": null,
          "alignment": null
        },
        {
          "value": "Amount (Monthly)",
          "is_header": true,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": false,
          "format": "string",
          "alignment": "center"
        },
        {
          "value": "$/SQFT (Monthly)",
          "is_header": true,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": false,
          "format": "string",
          "alignment": "center"
        },
        {
          "value": "% of Total Income (Monthly)",
          "is_header": true,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": false,
          "format": "string",
          "alignment": "center"
        },
        {
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": null,
          "shade": false,
          "value": null,
          "format": null
        },
        {
          "value": "Amount (Monthly)",
          "is_header": true,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": false,
          "format": "string",
          "alignment": "center"
        },
        {
          "value": "$/SQFT (Monthly)",
          "is_header": true,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": false,
          "format": "string",
          "alignment": "center"
        },
        {
          "value": "% of Total Income (Monthly)",
          "is_header": true,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": false,
          "format": "string",
          "alignment": "center"
        },
        {
          "value": null,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": null,
          "shade": false,
          "format": null,
          "alignment": null
        },
        {
          "value": "Amount (Monthly)",
          "is_header": true,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": false,
          "format": "string",
          "alignment": "center"
        },
        {
          "value": "$/SQFT (Monthly)",
          "is_header": true,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": false,
          "format": "string",
          "alignment": "center"
        },
        {
          "value": "% of Total Income (Monthly)",
          "is_header": true,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": false,
          "format": "string",
          "alignment": "center"
        }
      ]
    },
    {
      "meta": {},
      "data": [
        {
          "value": "Real Estate Taxes",
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": false,
          "format": "string",
          "alignment": "left"
        },
        {
          "value": 50000,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 2,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 15,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "percent",
          "alignment": "right"
        },
        {
          "value": null,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": null,
          "shade": true,
          "format": null,
          "alignment": null
        },
        {
          "value": 55000,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 2.2,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "value": 15,
          "format": "percent"
        },
        {
          "value": null,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": null,
          "shade": true,
          "format": null,
          "alignment": null
        },
        {
          "value": 60000,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 2.4,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 15,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "percent",
          "alignment": "right"
        }
      ]
    },
    {
      "meta": {},
      "data": [
        {
          "value": "General and Administrative",
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": false,
          "format": "string",
          "alignment": "left"
        },
        {
          "value": 50000,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 2,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 15,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "percent",
          "alignment": "right"
        },
        {
          "value": null,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": null,
          "shade": true,
          "format": null,
          "alignment": null
        },
        {
          "value": 55000,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 2.2,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "value": 15,
          "format": "percent"
        },
        {
          "value": null,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": null,
          "shade": true,
          "format": null,
          "alignment": null
        },
        {
          "value": 60000,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 2.4,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 15,
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "percent",
          "alignment": "right"
        }
      ]
    },
    {
      "meta": {},
      "data": [
        {
          "value": "Operating Expenses",
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": ["bold"],
          "shade": false,
          "format": "string",
          "alignment": "left"
        },
        {
          "value": 50000,
          "is_header": false,
          "is_total": false,
          "is_subtotal": true,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 2,
          "is_header": false,
          "is_total": false,
          "is_subtotal": true,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 15,
          "is_header": false,
          "is_total": false,
          "is_subtotal": true,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "percent",
          "alignment": "right"
        },
        {
          "value": null,
          "is_header": false,
          "is_total": false,
          "is_subtotal": true,
          "span": 1,
          "stylings": null,
          "shade": true,
          "format": null,
          "alignment": null
        },
        {
          "value": 55000,
          "is_header": false,
          "is_total": false,
          "is_subtotal": true,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 2.2,
          "is_header": false,
          "is_total": false,
          "is_subtotal": true,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "is_header": false,
          "is_total": false,
          "is_subtotal": true,
          "span": 1,
          "stylings": [],
          "shade": true,
          "value": 15,
          "format": "percent"
        },
        {
          "value": null,
          "is_header": false,
          "is_total": false,
          "is_subtotal": true,
          "span": 1,
          "stylings": null,
          "shade": true,
          "format": null,
          "alignment": null
        },
        {
          "value": 60000,
          "is_header": false,
          "is_total": false,
          "is_subtotal": true,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 2.4,
          "is_header": false,
          "is_total": false,
          "is_subtotal": true,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 15,
          "is_header": false,
          "is_total": false,
          "is_subtotal": true,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "percent",
          "alignment": "right"
        }
      ]
    },
    {
      "meta": {},
      "data": [
        {
          "value": "Totals",
          "is_header": false,
          "is_total": false,
          "is_subtotal": false,
          "span": 1,
          "stylings": ["bold"],
          "shade": false,
          "format": "string",
          "alignment": "left-indent"
        },
        {
          "value": 50000,
          "is_header": false,
          "is_total": true,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 2,
          "is_header": false,
          "is_total": true,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 15,
          "is_header": false,
          "is_total": true,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "percent",
          "alignment": "right"
        },
        {
          "value": null,
          "is_header": false,
          "is_total": true,
          "is_subtotal": false,
          "span": 1,
          "stylings": null,
          "shade": true,
          "format": null,
          "alignment": null
        },
        {
          "value": 55000,
          "is_header": false,
          "is_total": true,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 2.2,
          "is_header": false,
          "is_total": true,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "is_header": false,
          "is_total": true,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "value": 15,
          "format": "percent"
        },
        {
          "value": null,
          "is_header": false,
          "is_total": true,
          "is_subtotal": false,
          "span": 1,
          "stylings": null,
          "shade": true,
          "format": null,
          "alignment": null
        },
        {
          "value": 60000,
          "is_header": false,
          "is_total": true,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 2.4,
          "is_header": false,
          "is_total": true,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "dollar",
          "alignment": "right"
        },
        {
          "value": 15,
          "is_header": false,
          "is_total": true,
          "is_subtotal": false,
          "span": 1,
          "stylings": [],
          "shade": true,
          "format": "percent",
          "alignment": "right"
        }
      ]
    }
  ]
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/digital-om/components/models/custom-tables.js